<!--
 * @Description  : 文件预览
 * @Author       : 王帅
 * @Date         : 2023-06-16 16:55:17
 * @LastEditors  : zhanglei
 * @LastEditTime : 2025-05-28 14:14:06
 * @FilePath     : \dl_power_admin\src\components\bm-preview\preview-index.vue
-->
<template>
	<div
		class="full-preview"
		v-show="showPreview"
		:style="`top:${dialogSize.top};bottom:${dialogSize.bottom};left:${dialogSize.left};right:${dialogSize.right}`"
	>
		<div class="preview-title">
			<span class="text-overflow">{{ previewName }}</span>
			<span class="el-icon-close close-icon" @click="closePreview"></span>
		</div>
		<div class="preview-content">
			<iframe :src="previewUrl" frameborder="0" width="100%" height="100%"></iframe>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	name: '',
	data() {
		return {
			showPreview: false
		}
	},
	methods: {
		...mapActions('app', ['setPreviewUrl', 'setPreviewName', 'setDialogSize']),
		// 关闭
		closePreview() {
			this.setPreviewUrl('')
			this.setPreviewName('')
			this.setDialogSize({ top: '0', bottom: '0', left: '0', right: '0' })
		}
	},
	computed: {
		...mapState('app', {
			previewUrl: (state) => state.previewUrl,
			previewName: (state) => state.previewName,
			dialogSize: (state) => state.dialogSize
		})
	},
	watch: {
		previewUrl: {
			handler: function (url) {
				if (!!url) {
					this.showPreview = true
				} else {
					this.showPreview = false
				}
			},
			deep: true
		}
	}
}
</script>

<style scoped lang="less">
.full-preview {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 100000;
	background-color: #fff;

	.preview-title {
		height: 40px;
		line-height: 40px;
		display: flex;
		justify-content: space-between;
		padding: 0 20px;
		font-size: 16px;
		border-bottom: 1px solid #ccc;
		color: #3ba1ff;

		.close-icon {
			line-height: 40px;
			font-size: 20px;
			cursor: pointer;
			font-weight: 700;
			color: #000;
		}

		.close-icon:hover {
			color: #ff5722;
		}
	}

	.preview-content {
		height: calc(~'100% - 40px');
	}
}
</style>
